module.exports = __webpack_public_path__ + "img/groupm-nexus.f90b559d.png";